module.exports = __webpack_public_path__ + "img/clock.16718423.svg";